module.exports = __webpack_public_path__ + "img/logo.e3a1b9d8.png";